import { useSession } from "next-auth/react";
import { Button, useDisclosure, Text } from "@chakra-ui/react";
import { Stack } from "@chakra-ui/layout";
import toast from "react-hot-toast";
import { firebaseClient } from "firebaseClient";
import { CustomSection } from "components/custom-section";
import { getAccount } from "utils/sessionHelper";
import { ConfirmPopup } from "components/popups/confirmPopup";
import { postData } from "../../utils/helpers";
import { color, textStyle } from "theme/names";
import { IoWarningOutline } from "react-icons/io5";

import Link from "next/link";

export function DangerZone() {
  const { data: session } = useSession() ?? {};

  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleClick = () => {
    const subscription = getAccount(session)?.subscription;
    if (
      subscription?.isSubscribed &&
      !getAccount(session)?.subStatus?.includes("CancelRequest")
    ) {
      toast.error(
        "Can't delete your account, you have an active subscription. Unsubscribe first"
      );
      return;
    }

    onOpen();
  };

  const handleDelete = async () => {
    const db = firebaseClient.firestore();
    let docTweets = await db
      .collection("users")
      .doc(session?.user?.uid)
      .collection("tweets")
      .get();
    console.log("nb tweets to delete: " + docTweets.docs.length);

    // await async.mapLimit(docTweets.docs, 10, async (doc) => {
    docTweets.forEach((doc) => {
      console.log("delete tweets " + doc.id);
      db.collection("users")
        .doc(session?.user?.uid)
        .collection("tweets")
        .doc(doc.id)
        .delete();
    });

    let docAccounts = await db
      .collection("users")
      .doc(session?.user?.uid)
      .collection("accounts")
      .get();
    docAccounts.forEach((doc) => {
      console.log("delete account " + doc.id);
      db.collection("users")
        .doc(session?.user?.uid)
        .collection("accounts")
        .doc(doc.id)
        .delete();
    });

    console.log("delete user");
    await db.collection("users").doc(session?.user?.uid).delete();

    window.location.href = "https://taplio.com";
  };

  const username = getAccount(session)?.twUserName;
  return (
    <>
      {/* <CustomSection
        title="Danger zone"
        description="Careful, these actions are permanent"
      > */}
      <Text
        textStyle={textStyle["h3.bold.standard"]}
        // color={color["alert.lightMode.default"]}
      >
        Danger zone
      </Text>
      <Text mt={2} textStyle={textStyle["body.medium.light"]}>
        Careful, these actions are permanent
      </Text>
      <Text
        mt={0}
        textStyle={textStyle["body.medium.light"]}
        fontStyle={"italic"}
        color={"gray.600"}
      >
        <IoWarningOutline
          size="15px"
          style={{
            display: "inline-block",
            color: "red",
            position: "relative",
            top: "2px",
            marginRight: "3px",
          }}
        />{" "}
        <Text as="span"> Please Note: </Text>Deleting your account will not end
        your subscription, please make sure to end it in{" "}
        <Link
          href={"/settings?tab=billing"}
          style={{ color: "rgb(10, 102, 194)" }}
        >
          billing section
        </Link>{" "}
        prior to deleting account.
      </Text>
      <Stack pt={4}>
        <Button
          // colorScheme="red"
          // size="md"
          width="max-content"
          onClick={handleClick}
          variant="secondaryDestructive"
        >
          Delete my account
        </Button>
      </Stack>
      {/* </CustomSection> */}
      <ConfirmPopup
        isOpen={isOpen}
        onClose={onClose}
        title="Delete account confirmation"
        body={
          "This will permanently delete your account and all your data associated with it."
        }
        callback={handleDelete}
      />
    </>
  );
}
